export default "__VITE_ASSET__DN4aSL33__"